jQuery(document).ready(function($) {
	/**
	 * Fixed Sidebar Stuff on single event page
	 */

	// check our sidebar position on scroll so we can know to stop it or not
	if(window.innerWidth >= 850 && $('.fixed-scroll').length !== 0) {
		var adminBar = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;
		var navHeight = $('.main-header').height(); // height of nav
		var sidebarHeight = $('.fixed-scroll').height() + 8.3333; // height of only our fixed block
		var eventStatusHeight = $('.entry-header').height() + 50 + 8.3333; // height event status bar
		var topPosition = adminBar + eventStatusHeight - 50;
		var fixedTop = adminBar + navHeight + 50;
		var lastScrollTop = 0;
		$(window).scroll(function() {
			// window scroll position
			var windowScroll = $(window).scrollTop();

			// scroll positions
			var footerFromTop = $('.related-posts').offset().top; // scroll position from top of footer to top of document

			// if our window has scrolled past our sidebar, taking into account our fixed nav and padding
			if ((windowScroll > topPosition)) {
				if (windowScroll < footerFromTop - sidebarHeight - adminBar - 200) {
					var st = $(this).scrollTop();
					if (st > lastScrollTop){
						console.log('down')
						$('.fixed-scroll').addClass('animateDown');
					} else {
						console.log('up')
					}
					lastScrollTop = st;
					var sidebarWidth = $('.event-info').width();
					$('.single-event .entry-content').css({
						alignItems: 'flex-start'
					});
					$('.fixed-scroll').css({
						position: 'fixed',
						top: fixedTop + 'px',
						width: sidebarWidth + 'px'
					});
				} else {
					$('.single-event .entry-content').css({
						alignItems: 'flex-end'
					});
					// $('.fixed-scroll').removeClass('animateDown');
					$('.fixed-scroll').css({
						position: 'static',
						top: '',
						width: 'auto'
					});
				}
			} else {
				$('.single-event .entry-content').css({
					alignItems: 'flex-start'
				});
				$('.fixed-scroll').removeClass('animateDown');
				$('.fixed-scroll').css({
					position: 'static',
					top: '',
					width: 'auto'
				});
			}
		});
	}

	const backgroundColor = $('.status-msg').css( "background-color" );
	$('.status-msg a').hover(
		function() {
			$( this ).css('color', backgroundColor);
		}, function() {
			$( this ).css('color', 'white');
		}
	)

	$('.event-item .links a.button, .event-item .links button, .related-posts .event-info a.button, .related-posts .event-info button, .entry-content .event-info a.button, .entry-content .event-info button').each(function() {
		const backgroundColor = $(this).attr('data-color');
		if (backgroundColor) {
			const darkHoverColor = LightenDarkenColor(backgroundColor, -20);
			$(this).css('background-color', backgroundColor);
			$(this).css('box-shadow', '0 0 10px ' + backgroundColor);
			$(this).hover(
				function () {
					$(this).css('background-color', darkHoverColor);
				}, function() {
					$(this).css('background-color', backgroundColor);
				}
			)
            $(this).css('outline-color', backgroundColor);
		}
	});

    $('li.sf-field-submit').attr('tabindex', '0');
	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
		/**
		 * Fixed Sidebar Stuff on single event page
		 */

		// check our sidebar position on scroll so we can know to stop it or not
		if(window.innerWidth >= 850 && $('.fixed-scroll').length !== 0) {
			var adminBar = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;
			var navHeight = $('.main-header').height(); // height of nav
			var sidebarHeight = $('.fixed-scroll').height() + 8.3333; // height of only our fixed block
			var eventStatusHeight = $('.entry-header').height() + 50 + 8.3333; // height event status bar
			var topPosition = adminBar + eventStatusHeight - 50;
			var fixedTop = adminBar + navHeight + 50;
			var lastScrollTop = 0;
			$(window).scroll(function() {
				// window scroll position
				var windowScroll = $(window).scrollTop();

				// scroll positions
				var footerFromTop = $('.related-posts').offset().top; // scroll position from top of footer to top of document

				// if our window has scrolled past our sidebar, taking into account our fixed nav and padding
				if ((windowScroll > topPosition)) {
					if (windowScroll < footerFromTop - sidebarHeight - adminBar - 200) {
						var st = $(this).scrollTop();
						if (st > lastScrollTop){
							console.log('down')
							$('.fixed-scroll').addClass('animateDown');
						} else {
							console.log('up')
						}
						lastScrollTop = st;
						var sidebarWidth = $('.event-info').width();
						$('.single-event .entry-content').css({
							alignItems: 'flex-start'
						});
						$('.fixed-scroll').css({
							position: 'fixed',
							top: fixedTop + 'px',
							width: sidebarWidth + 'px'
						});
					} else {
						$('.single-event .entry-content').css({
							alignItems: 'flex-end'
						});
						// $('.fixed-scroll').removeClass('animateDown');
						$('.fixed-scroll').css({
							position: 'static',
							top: '',
							width: 'auto'
						});
					}
				} else {
					$('.single-event .entry-content').css({
						alignItems: 'flex-start'
					});
					$('.fixed-scroll').removeClass('animateDown');
					$('.fixed-scroll').css({
						position: 'static',
						top: '',
						width: 'auto'
					});
				}
			});
		}

		const backgroundColor = $('.status-msg').css( "background-color" );
		$('.status-msg a').hover(
			function() {
				$( this ).css('color', backgroundColor);
			}, function() {
				$( this ).css('color', 'white');
			}
		)

		$('.event-item .links a.button, .event-item .links button, .related-posts .event-info a.button, .related-posts .event-info button, .entry-content .event-info a.button, .entry-content .event-info button').each(function() {
			const backgroundColor = $(this).attr('data-color');
			console.log(backgroundColor)
			if (backgroundColor) {
				const darkHoverColor = LightenDarkenColor(backgroundColor, -20);
				$(this).css('background-color', backgroundColor);
				$(this).css('box-shadow', '0 0 10px ' + backgroundColor);
				$(this).hover(
					function () {
						$(this).css('background-color', darkHoverColor);
					}, function() {
						$(this).css('background-color', backgroundColor);
					}
				)
			}
		});

	});
});

function LightenDarkenColor(col, amt) {
	var usePound = false;
	if (col[0] == "#") {
		col = col.slice(1);
		usePound = true;
	}
	var num = parseInt(col,16);
	var r = (num >> 16) + amt;
	if (r > 255) {
		r = 255;
	} else if (r < 0) {
		r = 0;
	}
	var b = ((num >> 8) & 0x00FF) + amt;
	if (b > 255) {
		b = 255;
	} else if (b < 0) {
		b = 0;
	}
	var g = (num & 0x0000FF) + amt;
	if (g > 255) {
		g = 255;
	} else if (g < 0) {
		g = 0;
	}
	return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}
